// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"7ad5fc31","238":"12573bc6","453":"68693753"}[chunkId] + ".chunk.js";
};